// This is a magic string replaced by rollup

const SDK_VERSION = "8.55.2" ;

export { SDK_VERSION };
//# sourceMappingURL=version.js.map
